interface ChatBubbleProps {
  text: string;
  visible: boolean;
  side?: 'left' | 'right';
}

export default function ChatBubble({ text, visible, side = 'left' }: ChatBubbleProps) {
  if (!visible) return null;

  return (
    <div
      className={`
        absolute bottom-full mb-2 z-30 pointer-events-none
        ${side === 'left' ? 'left-1/2 -translate-x-1/2' : 'left-1/2 -translate-x-1/2'}
        animate-bubble-in
      `}
    >
      <div className="relative bg-bg-tertiary/95 border border-border-subtle rounded-lg px-2.5 py-1.5 max-w-[180px] shadow-lg">
        <p className="text-[10px] leading-tight text-text-primary whitespace-pre-wrap">
          {text}
        </p>
        {/* Tail pointing down */}
        <div className="absolute top-full left-1/2 -translate-x-1/2 w-0 h-0 border-l-[5px] border-l-transparent border-r-[5px] border-r-transparent border-t-[5px] border-t-bg-tertiary/95" />
      </div>
    </div>
  );
}
